<template>
    <div>
        <Header></Header>
        <div id="content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
  import Header from '@/components/Header.vue'

  export default {
    components: {
      Header
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Main.vue